export default __webpack_public_path__ + "static/media/img-0775-sweden-half-face.33a8733e.png";